import { getAuthToken } from "./authService";

export const API_BASE =
  (typeof process !== "undefined" && process?.env?.REACT_APP_API_BASE) ||
  (typeof window !== "undefined" && window.API_BASE) ||
  "https://api.globalwineinstitute.org";
export const DEFAULT_HEADERS = {
  "X-API-KEY": "f3bb4afa55070cc052d1b888d4f7465a",
};

export const getApiBase = () => {
  if (API_BASE) return API_BASE;
  if (typeof window !== "undefined" && window.API_BASE) return window.API_BASE;
  throw new Error("API_BASE is not defined");
};

export const buildApiUrl = (path = "") => {
  if (!path) return getApiBase();
  if (/^https?:\/\//i.test(path)) return path;
  return `${getApiBase()}${path.startsWith("/") ? path : `/${path}`}`;
};

export const createHeaders = ({
  json = true,
  userId,
  overrides = {},
} = {}) => {
  const token = getAuthToken();
  const base = {
    ...DEFAULT_HEADERS,
    ...(json
      ? { "Content-Type": "application/json", Accept: "application/json" }
      : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(userId ? { "X-User-Id": String(userId) } : {}),
  };
  return { ...base, ...overrides };
};
